import React, { useContext, useState, useEffect } from "react";
import { CartContext } from "../components/CartContext";
import { useWishlist } from "../components/WishlistContext";
import { Link } from "react-router-dom";
import '../css/ProductCard.css';
import ScrollTop from "../components/scrollTop";

export default function WishlistPage() {
    const { addToCart } = useContext(CartContext);
    const { wishlistItems, toggleWishlist } = useWishlist();

    const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleAddToCart = (product) => {
        addToCart(product);
        setAlert({ visible: true, message: `${product.name} added to cart!`, type: "success" });
        setTimeout(() => setAlert({ visible: false, message: "", type: "" }), 3000);
    };

    return (
        <div className="container py-5">
            <ScrollTop />
            {/* Alert */}
            {alert.visible && (
                <div
                    className={`bg-primary text-white alert alert-${alert.type} alert-dismissible fade show fixed-top mt-3 mx-auto`}
                    role="alert"
                    style={{ zIndex: 1050, width: 'fit-content', minWidth: '300px' }}
                >
                    <i className="fa-solid fa-check-circle me-2"></i>
                    {alert.message}
                    <button type="button" className="btn-close" onClick={() => setAlert({ visible: false, message: "", type: "" })}></button>
                </div>
            )}

            <h2 className="mb-4">My Wishlist</h2>

            {wishlistItems.length === 0 ? (
                <p className="text-center text-muted">Your wishlist is empty.</p>
            ) : (
                <div className="row g-4">
                    {wishlistItems.map(product => {
                        const productLink = product.subcategory
                            ? `/product/${product.category}/${product.subcategory}/${product.id}`
                            : `/product/${product.category}/${product.id}`;

                        return (
                            <div key={product.id} className="col-12 col-sm-6 col-md-4 col-lg-3">
                                <div className="card h-100 border-0 rounded-3 overflow-hidden shadow-sm product-card-hover">
                                    {/* Best Seller Badge */}
                                    <div className="position-absolute top-0 start-0 m-3">
                                        <span className="badge bg-dark text-white px-3 py-2 rounded-pill">Best Seller</span>
                                    </div>

                                    {/* Wishlist Button */}
                                    <button
                                        className="btn btn-light position-absolute top-0 end-0 m-3 rounded-circle shadow-sm"
                                        onClick={() => toggleWishlist(product)}
                                        style={{ width: '40px', height: '40px', padding: 0, zIndex: 999 }}
                                    >
                                        <i className="fa-solid fa-heart fa-sm text-danger"></i>
                                    </button>

                                    {/* Product Image */}
                                    <div className="product-image-container">
                                        <Link to={productLink} className="d-block w-100 h-100">
                                            <img src={product.image} className="product-image" alt={product.name} />
                                        </Link>
                                    </div>

                                    {/* Product Info */}
                                    <div className="card-body p-4">
                                        <p className="text-uppercase text-muted small mb-1 fw-bold">
                                            {product.subcategory || product.category}
                                        </p>

                                        <Link to={productLink} className="text-decoration-none text-dark">
                                            <h5 className="card-title fw-bold mb-2" style={{ fontSize: '1.1rem', lineHeight: '1.3' }}>
                                                {product.name.slice(0,30)}...
                                            </h5>
                                        </Link>

                                        <p className="text-dark small mb-4" style={{ lineHeight: '1.4', fontSize: '0.85rem' }}>
                                            {product.description.slice(0,60)}...
                                        </p>

                                        <div className="d-flex justify-content-between align-items-center mt-4">
                                            <div className="d-flex align-items-baseline">
                                                <span className="fw-bold fs-4 text-dark">
                                                    ${product.price}
                                                </span>
                                                {product.oldPrice && (
                                                    <span className="text-muted text-decoration-line-through ms-2 small">
                                                        ${product.oldPrice}
                                                    </span>
                                                )}
                                            </div>

                                            <button
                                                className="btn btn-dark rounded-pill px-4 py-2 fw-bold buy-now-btn"
                                                onClick={() => handleAddToCart(product)}
                                                style={{ fontSize: '0.9rem', transition: 'all 0.3s ease' }}
                                            >
                                                Add to Cart <i className="fa-solid fa-arrow-up-right-from-square"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
}
